
import React from 'react'
import PropTypes from 'prop-types'
// styles
import './heart-loading.scss'

function HeartLoading({ label, className }) {

  const rootClass = (className) ? `HeartLoading ${className}` : 'HeartLoading'

  return (
    <div className={rootClass}>
      <div className="rhombus">
        <div className="circle1"></div>
        <div className="circle2"></div>
      </div>
      <div className="text">
        <p>{label}</p>
      </div>
    </div>
  )
}

HeartLoading.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
}

HeartLoading.defaultProps = {
  className: '',
  label: 'Carregando ...'
}

export default HeartLoading

